var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "106px",
        height: "106px",
        viewBox: "0 0 106 106",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs", [
        _c("polygon", {
          attrs: {
            id: "path-1",
            points:
              "0 0.000193220339 35.7670169 0.000193220339 35.7670169 56.5084475 0 56.5084475"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-HD",
                transform: "translate(-631.000000, -413.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group",
                    transform: "translate(631.000000, 413.000000)"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M106,90.9548646 C106,99.2637914 99.2146745,106 90.8451633,106 L15.1548367,106 C6.78532554,106 0,99.2637914 0,90.9548646 L0,15.0451354 C0,6.73520562 6.78532554,0 15.1548367,0 L90.8451633,0 C99.2146745,0 106,6.73520562 106,15.0451354 L106,90.9548646 Z",
                      id: "Mask",
                      fill: "#BB3484"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group-3",
                        transform: "translate(35.000000, 25.000000)"
                      }
                    },
                    [
                      _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                        _c("use", { attrs: { "xlink:href": "#path-1" } })
                      ]),
                      _vm._v(" "),
                      _c("g", { attrs: { id: "Clip-2" } }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M30.4633119,31.3737661 L23.4726,31.3737661 L12.2957695,31.3737661 L5.30505763,31.3737661 L3.61824407,22.1165797 L7.59182034,22.1165797 L28.1765492,22.1165797 L32.1501254,22.1165797 L30.4633119,31.3737661 Z M13.9420068,53.2163593 L21.8273288,53.2163593 L21.8273288,34.6643085 L13.9420068,34.6643085 L13.9420068,53.2163593 Z M12.2851424,12.7028847 L13.0696169,18.8250712 L8.96368475,18.8250712 L7.84880339,12.7028847 L12.2851424,12.7028847 Z M20.584922,12.7028847 L19.8004475,18.8250712 L15.967922,18.8250712 L15.1834475,12.7028847 L20.584922,12.7028847 Z M27.9195661,12.7028847 L26.8027525,18.8250712 L22.6987525,18.8250712 L23.4832271,12.7028847 L27.9195661,12.7028847 Z M35.3865661,19.4163254 C35.0745153,19.0405119 34.6107864,18.8250712 34.121939,18.8250712 L30.1483627,18.8250712 L31.5105661,11.3522746 C31.5975153,10.872122 31.4670915,10.3794102 31.1540746,10.0045627 C30.8429898,9.62874915 30.3802271,9.41330847 29.8913797,9.41330847 L19.5289729,9.41330847 L19.5289729,3.29208814 L23.4726,3.29208814 C24.3817017,3.29208814 25.1178712,2.55495254 25.1178712,1.64585085 C25.1178712,0.737715254 24.3817017,-0.000386440678 23.4726,-0.000386440678 L12.2957695,-0.000386440678 C11.3866678,-0.000386440678 10.6504983,0.737715254 10.6504983,1.64585085 C10.6504983,2.55495254 11.3866678,3.29208814 12.2957695,3.29208814 L16.2393966,3.29208814 L16.2393966,9.41330847 L5.87698983,9.41330847 C5.38814237,9.41330847 4.92537966,9.62874915 4.61236271,10.0045627 C4.29934576,10.3794102 4.17085424,10.872122 4.25780339,11.3522746 L5.61807458,18.8250712 L1.64449831,18.8250712 C1.15758305,18.8250712 0.695786441,19.0405119 0.38180339,19.4163254 C0.0687864407,19.7911729 -0.0616372881,20.2838847 0.0253118644,20.7659695 L2.31400678,33.3156305 C2.45602373,34.0962407 3.13712542,34.6643085 3.93126102,34.6643085 L10.6504983,34.6643085 L10.6504983,54.8625966 C10.6504983,55.7716983 11.3866678,56.5088339 12.2957695,56.5088339 L23.4726,56.5088339 C24.3817017,56.5088339 25.1178712,55.7716983 25.1178712,54.8625966 L25.1178712,34.6643085 L31.8351763,34.6643085 C32.6312441,34.6643085 33.3123458,34.0962407 33.4543627,33.3156305 L35.7411254,20.7659695 C35.8280746,20.2838847 35.6995831,19.7911729 35.3865661,19.4163254 L35.3865661,19.4163254 Z",
                          id: "Fill-1",
                          fill: "#FFFFFF",
                          mask: "url(#mask-2)"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }